module.exports = __webpack_public_path__ + "img/23.bc27d1f7.webp";